import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'

interface AuthGuardProps {
  children: React.ReactNode
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, userType, isLoading } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!isLoading && (!isAuthenticated || userType !== 'applicant')) {
      // Redirect to magic link login page with current state preserved
      navigate('/auth/magic-link', {
        state: location.state,
        replace: true
      })
    }
  }, [isAuthenticated, userType, isLoading, navigate, location.state])

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex items-center space-x-2">
          <Loader2 className="h-6 w-6 animate-spin" />
          <span>Checking authentication...</span>
        </div>
      </div>
    )
  }

  // Don't render protected content if not authenticated as applicant
  if (!isAuthenticated || userType !== 'applicant') {
    return null
  }

  return <>{children}</>
}